export const dataDefault = [{
    name: "Efficiency Per Total Room Area SQM 客房可售总面积坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 0,
}, {
    name: "Total Conference Space SQM 会议室可售总面积坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 1,
}, {
    name: "Efficiency Per Seat No. of Total Restaurant 餐厅总餐位数坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 2,
}, {
    name: "Efficiency Per Total Restaurant Space SQM 餐厅总面积坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 3,
}, {
    name: "Efficiency Per Seat No. of All Day Dinning 全日餐厅位数坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 4,
}, {
    name: "Efficiency Per All Day Dinning Space SQM 全日餐厅面积坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 5,
}, {
    name: "Efficiency Per Seat No. of Chinese Restaurant 中餐大厅位数坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 6,
}, {
    name: "Efficiency Per Chinese Restaurant Space SQM 中餐厅面积坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 7,
}, {
    name: "Efficiency Per Seat No. of Lounge/Bar 大堂吧/酒吧餐位数坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 8,
}, {
    name: "Efficiency Per Lounge/Bar Space SQM 大堂吧面积坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 9,
}, {
    name: "Efficiency Per Seat No. of Special Restaurant 特色餐厅餐位数坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 10,
}, {
    name: "Efficiency Per Spacial Restaurant Space SQM 特色餐厅面积坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 11,
}, {
    name: "Efficiency Per Seat No. of Other Outlets 其他餐厅餐位数坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 12,
}, {
    name: "Efficiency Per Other Outlets Space SQM 其他餐厅面积坪效",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 13,
}]

export const intervalData = {
    1: "一亿以上",
    2: "8000万-1亿",
    3: "6500万-8000万",
    4: "5500万-6500万",
    5: "4500万-5500万",
    6: "3500万-4500万",
    7: "2500万-3500万",
    8: "1000万-2500万",
    9: "小于1000万",
}; 


// WEBPACK FOOTER //
// ./src/components/table/effect/data.js